import React from 'react';
import { SubTitle } from '../Text';
import { StyledTableBox, StyledTableContainer, StyledTableHeader } from './Table.styled';
export function TableContainer(_ref) {
  var header = _ref.header,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, header && /*#__PURE__*/React.createElement(StyledTableHeader, null, /*#__PURE__*/React.createElement(SubTitle, null, header)), /*#__PURE__*/React.createElement(StyledTableContainer, null, children));
}
export function Box(_ref2) {
  var header = _ref2.header,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(TableContainer, {
    header: header
  }, /*#__PURE__*/React.createElement(StyledTableBox, null, children));
}